import { Component, OnInit, Input, HostBinding, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioCardInterface } from 'src/app/core/interfaces/radio-card.interface';
import { SelectMultipleValueInterface } from 'src/app/core/interfaces/select-multiple.interface';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, AfterViewInit {

  @Input() FORM_DATA: FormGroup;
  /**
   * @description Es la configuracion del formulario
   */
  @Input() DATA_CONFIG: any;

  // @HostBinding( 'class.contratacion__detail' ) apply = true;

  insureSelected: { name: string, chosed: string };
  typeStudents = '';

  @HostBinding('class.contratacion__detail') apply = true;
  /**
   * @description constructor
   */
  constructor() {
  }
  /**
   * @description metodo inicio
   */
  ngOnInit(): void {
    this.getProductChoosed();
  }
  /**
   * @description recuprar producto
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value;
    }
  }
  /**
   * @description recuprar valor formulario
   * @params prop
   * @returns any
   */
  getFormValue(prop: string[]): string | number |
  RadioCardInterface | {name: string, id: number} | SelectMultipleValueInterface[] | SelectMultipleValueInterface {
    if (this.FORM_DATA) {
      if (this.FORM_DATA.get(prop).value.title === 'Precio') {
        this.FORM_DATA.get(prop).value.title = 'Temporal';
      }
      return this.FORM_DATA.get(prop).value;
    }
  }
  /**
   * @description recuperar pais destino
   */
  getCountryDestiny(): string {
    let returnV: string;
    const CHOSED: any = this.getFormValue([this.insureSelected.chosed, 'countryDestiny']);
    const LIST_NAME_CHOSED: any[] = [];
    if (Array.isArray(CHOSED)) {
      CHOSED.forEach((item: any) => {
        LIST_NAME_CHOSED.push(item.name);
      });
      returnV = LIST_NAME_CHOSED.join(' - ');
      // returnV = chosed[ 0 ].name;
    } else if (CHOSED.name !== undefined) {
      returnV = CHOSED.name;
    } else {
      returnV = CHOSED;
    }
    return returnV;
  }
  /**
   * @description recuperar pais origen
   */
  getCountryOrigin(): string {
    let returnV: string;
    const CHOSED: any = this.getFormValue([this.insureSelected.chosed, 'countryOrigin']);
    if (CHOSED.name !== undefined) {
      returnV = CHOSED.name;
    } else {
      returnV = CHOSED;
    }
    return returnV;
  }

  /**
   * @description Despues de cargar la vista
   */
  ngAfterViewInit(): void {
    const linkToggle: NodeListOf<Element> = document.querySelectorAll('.js-toggle');
    linkToggle.forEach(element => {
      element.addEventListener('click', function(event: Event): void {
        event.preventDefault();
        const container: HTMLElement = document.getElementById(this.dataset.container);
        if (container.classList.contains('active')) {
          container.classList.add('inactive');
          container.classList.remove('active');
        } else {
          container.classList.add('active');
          container.classList.remove('inactive');
        }
      });
    });
  }
}
